import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_RESIGNED_EMPLOYEE_HISTORY_REPORT_API} from '@app/reactQuery/apis/constants/rqResignedEmployeesHistoryReportAPIConstants';

export const RQUseGetResignedEmployeesHistoryReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_resigned_employees_history_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, year, employeeCode} = queryKey[1];
      console.log({year, employeeCode});

      return rqCreateSearchRequest(
        RQ_GET_RESIGNED_EMPLOYEE_HISTORY_REPORT_API,
        null,
        certificate,
        {year: year, employeeCode: employeeCode},
        signal,
      );
    },
    ...options,
  });
};
